function autoMapper(sourse, target, formatter) {
    if (!target || !sourse) {
        return;
    }
    let sourseKeys = Object.keys(sourse);
    sourseKeys.forEach(key => {
        if (!target.hasOwnProperty(key)) {
            return;
        }
        let value = sourse[key];
        if (typeof value === "object") {
            autoMapper(value, target[key], formatter);
        } else {
            if (formatter) {
                target[key] = formatter(key);
            } else {
                target[key] = value;
            }
        }
    });
}

export default autoMapper;